import script from "./EmptyWebLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyWebLayout.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyWebLayout.vue?vue&type=style&index=0&id=30cc60e7&scoped=true&lang=css"

import exportComponent from "../../../../../../deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30cc60e7"]])

export default __exports__